const selectors = {
  sectionId: "api-cartmagician-launch3d-button",
}

class ARHelper {
  constructor() {
    this.init()
  }

  init() {
    this.addListeners()
  }

  addListeners() {
    window.addEventListener("openARTrigger", this.onOpenAR.bind(this))
    document.addEventListener("click", this.customGlobalClick.bind(this))
  }


  async customGlobalClick(event) {

    const button = event?.target?.closest("[data-js-custom-click-view-room]")

    if (!button) {
      return null
    }

    const handle = button.getAttribute("data-js-custom-click-view-room")

    if (!handle) {
      return null
    }

    try {
      const arTemplates = await this.getApiTemplate(handle);
      const htmlTemplates = this.parseTemplate(arTemplates);
      const mobileTemplate = htmlTemplates.querySelector(".mobile-ar-template-custom");
      this.templateId = mobileTemplate?.id;
      this.openAR(mobileTemplate.id, htmlTemplates);

    } catch (error) {
      console.error('AR Modal Error:', error);
    }
  }

  async getApiTemplate(handle) {

    const response = await fetch(`/products/${handle}/?section_id=${selectors.sectionId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })

    return await response.text()
  }

  parseTemplate(template) {
    return new DOMParser().parseFromString(template, "text/html")
  }

  onOpenAR(event) {
    this.templateId = event.detail?.templateId
    this.openAR(this.templateId);
  }

  openAR(templateID, requestTemplate = null) {

    if (!templateID && !requestTemplate) {
      return null
    }

    if (this.isMobile()) {
      window.dispatchEvent(new CustomEvent("mobileDrawerOpen", {
          detail:
            {
              templateId: templateID,
              requestTemplate: requestTemplate
            },
        }),
      )
    } else {
      requestTemplate ?
        this.loadTemplateFromRequest(templateID, requestTemplate) :
        this.loadTemplateFromDOM(templateID)

      this.renderDrawer()
    }
  }

  addDrawerListeners() {
    window.addEventListener("closeARTrigger",
      this.removeDrawer.bind(this))
  }

  loadTemplateFromRequest(templateID, requestTemplate) {
    const template = requestTemplate.querySelector(
      "#desktop-" + templateID)
    if (template) {
      this.templateHTML = template.content.cloneNode(true)
    }
  }

  loadTemplateFromDOM() {
    const template = document.getElementById(`desktop-${this.templateId}`)
    if (template) {
      this.templateHTML = template.content.cloneNode(true)
    }
  }


  renderDrawer() {
    if (this.drawerElement) return
    this.drawerElement = document.createElement("div")
    this.drawerId = `ar-modal-${this.templateId}`
    this.drawerElement.setAttribute("id", this.drawerId)
    this.drawerElement.classList.add("ar-product__modal")
    this.drawerElement.appendChild(this.templateHTML)
    document.body.appendChild(this.drawerElement)
    this.addDrawerListeners()
  }

  removeDrawer() {
    if (this.drawerElement) {
      document.body.removeChild(this.drawerElement)
      this.drawerElement = null
    }
  }

  isMobile() {
    return /iPhone|iPod|iPad|Android/i.test(navigator.userAgent)
  }
}


export default ARHelper
